module.exports = __webpack_public_path__ + "img/5-krabpalen.c49540d7.jpg";